<template>
  <div class="text-center container-done">
      <img src="@/assets/images/tick.svg" alt="" width="180" height="180">
      <p class="tanks">
          Gracias por responder.
      </p>
        <p class="text-small">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.
        </p>
  </div>
</template>

<script>

export default {
    name: "RomaDonePoll"
}
</script>

<style lang="scss" scoped>
    .container-done {
        padding-top: 80px;
        img {
            width: 120px !important;
        }
        .tanks {
        font-family: cabin, Regular,serif;
        font-size: 28px;
        color: #484848;
        width: 60%;
        margin-left: 20%;
        text-align: center;
    }

    .text-small {
        display: none;
        font-size: 14px !important;
        color: #484848;
        width: 70%;
        margin-top: 5px;
        margin-left: 15%;
        }
    }
    

</style>